import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Table from "../../components/Table/Table.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter";
import SaveResultsButton from "../../components/CustomButtons/SaveResultsButton";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
};

const useStyles = makeStyles(styles);

export default function Results() {
  const classes = useStyles();

  const location = useLocation();
  const { matrix, rankedAlternatives, criteriaSelected, alternativesNames } = location.state || {};

  const [alternativesWithRank, setAlternativesWithRank] = useState(
    rankedAlternatives
  );

  useEffect(() => {
    const addedRank = rankedAlternatives.map((row, rowIndex) => [
      ...row,
      rowIndex + 1,
    ]);
    setAlternativesWithRank(addedRank);
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="success">
            <h4 className={classes.cardTitleWhite}>Rezultati</h4>
            <p className={classes.cardCategoryWhite}>Rangirane alternative</p>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="success"
              tableHead={["Naziv", "Vrijednost funkcije korisnosti", "Rang"]}
              tableData={alternativesWithRank}
              rankTable={true}
            />
          </CardBody>
          <CardFooter>
            <SaveResultsButton tableData={alternativesWithRank} inputData = { matrix } criteriaSelected={criteriaSelected} alternativesNames={alternativesNames}/>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

